
export default class ApiValidationErrorModel {
    public errorCode: string = '';
    public errorDescription: string = '';
}
